import { Reveal } from "./Reveal";

export const SectionHead = ({ eyebrow, title, text, dark = false, align = "center" }) => (
  <Reveal
    className={`${align === "center" ? "text-center" : "text-left"} pt-20 sm:pt-24 pb-12 sm:pb-14 px-6`}
  >
    <p className={`eyebrow ${dark ? "text-gold-soft" : "text-gold-dark"}`}>{eyebrow}</p>
    <h2
      className={`font-serif font-medium tracking-tight text-3xl sm:text-4xl lg:text-[44px] leading-[1.08] mt-5 ${
        dark ? "text-cream" : "text-forest"
      } ${align === "center" ? "max-w-3xl mx-auto" : "max-w-2xl"}`}
    >
      {title}
    </h2>
    <div className={`w-14 h-px bg-gold my-6 ${align === "center" ? "mx-auto" : ""}`} />
    {text && (
      <p
        className={`text-sm sm:text-[15px] leading-relaxed ${
          dark ? "text-cream/60" : "text-sage"
        } ${align === "center" ? "max-w-xl mx-auto" : "max-w-xl"}`}
      >
        {text}
      </p>
    )}
  </Reveal>
);
